
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export const useAuthHandling = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSignIn = async (email: string, password: string) => {
    setError("");
    setLoading(true);

    try {
      console.log("Tentative de connexion avec:", { email });

      const { data, error: signInError } = await supabase.auth.signInWithPassword({
        email: email.toLowerCase(),
        password
      });

      if (signInError) {
        console.error("Erreur de connexion détaillée:", signInError);
        throw signInError;
      }

      if (data.user) {
        console.log("Connexion réussie pour:", data.user.email);
        
        const { data: profileData, error: profileError } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', data.user.id)
          .single();

        if (profileError) {
          console.error("Erreur lors de la récupération du profil:", profileError);
          
          const { error: createProfileError } = await supabase
            .from('profiles')
            .insert([
              {
                id: data.user.id,
                email: data.user.email,
                type: 'patient',
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString()
              }
            ]);

          if (createProfileError) {
            console.error("Erreur lors de la création du profil:", createProfileError);
            throw createProfileError;
          }
        }

        toast({
          title: "Connexion réussie",
          description: "Vous êtes maintenant connecté",
        });

        if (profileData?.type === 'professional') {
          navigate("/professional");
        } else {
          navigate("/");
        }
      }
    } catch (error: any) {
      console.error("Erreur complète:", error);
      
      const errorMessage = error.message?.toLowerCase() || "";
      if (errorMessage.includes("invalid login credentials")) {
        setError("Email ou mot de passe incorrect");
      } else {
        setError(error.message || "Une erreur est survenue lors de la connexion");
      }
      
      toast({
        variant: "destructive",
        title: "Erreur de connexion",
        description: "Vérifiez vos identifiants et réessayez.",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handleSignIn
  };
};
